import { css } from '@emotion/react';

import { useQuery } from 'react-query';

import { useModal } from '@hooks/useModal';
import { minutesToMilliseconds } from 'date-fns';

import HomeSectionSkeleton from '@components/skeleton/HomeSectionSkeleton';

import { fetchCurationByType } from '@api/section';
import { fetchStoryAd } from '@api/story';
import { CurationType, CurationViewType, QUERY_KEYS } from '@constants';
import { useAnalytics } from '@utils/analytics';

import PopupModal from '../modal/PopupModal';
import RcommendationStorySection from './RecommendationStorySection';

const containerCSS = css`
  overflow-x: hidden;
`;

const RECOMMENDATION_CURATION_TYPE = CurationType.standardTabRecommend;

const RecommendationSectionList = () => {
  const { firebase } = useAnalytics();
  const { data: recommendation, isLoading } = useQuery(
    QUERY_KEYS.SECTION(RECOMMENDATION_CURATION_TYPE),
    () => fetchCurationByType(RECOMMENDATION_CURATION_TYPE),
    {
      staleTime: 1000 * 60 * 15,
      cacheTime: 1000 * 60 * 15,
      suspense: false,
    }
  );

  const [isPopupModalOpen, { open: openPopupModal, close: closePopupModal }] =
    useModal('popup-modal', {
      routeChange: false,
    });

  const visibleSections =
    recommendation?.sections?.filter(
      ({ viewType }) =>
        viewType !== CurationViewType.userRanking &&
        viewType !== CurationViewType.honorUser
    ) ?? [];
  const hasAd = visibleSections.some((section) => section.hasAd);
  const { data: storyAd } = useQuery(QUERY_KEYS.AD.STORY(), fetchStoryAd, {
    enabled: !!hasAd,
    suspense: false,
    staleTime: minutesToMilliseconds(5),
  });

  return (
    <>
      {isLoading && <HomeSectionSkeleton />}

      {visibleSections.map((section, visibleIndex) => {
        const visibleCount = visibleIndex + 1;
        const showNativeAd = visibleCount >= 2 && (visibleCount - 2) % 3 === 0;

        const handleClickCuration = () => {
          firebase.logEvent('home_curation_click', {
            title: section?.name ?? '',
          });
        };

        return (
          <div
            css={containerCSS}
            onClick={handleClickCuration}
            key={section.id}
          >
            <RcommendationStorySection
              section={section}
              ad={storyAd}
              openPopupModal={openPopupModal}
              showNativeAd={showNativeAd}
              showFreeChatCta={false}
            />
          </div>
        );
      })}
      <PopupModal
        open={isPopupModalOpen}
        onClose={closePopupModal}
        name="popup-modal"
      />
    </>
  );
};

export default RecommendationSectionList;
